/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {
    RECEIVE_CLIENT_REPORTS_DATA,
    REMOVE_REPORT_DATA,
    GET_CLIENT_EMAILS,
    UPDATE_MODE,
    SET_LIBRARY_PRICESSING
} from 'state/actions/reportsState/reports_status';
import { CLEAR_ALL_STATES } from 'state/actions/auth_status';
// utils
import {countriesWithCodes} from 'utils/api/reports';



/* ========== ~~~~~~~~~~ REPORTS STATE > REPORTS STATUS: REDUCER ~~~~~~~~~~ ========== */


// ^-^ ^-^ ^-^ ^-^ ^-^   DEFAULT STATE   ^-^ ^-^ ^-^ ^-^ ^-^ //

const defaultState = {
    isDataReceived: false,
    mode: 'library', // this value should be updated by the actions we're taking with reports (library, create, edit, preview)
    clientReports: [],
    clientEmails: [],
    allCountries: countriesWithCodes,
    allDevices: ["DESKTOP", "MOBILE"],
    previewReportData: {},
    existingReports: [], //an array of objects holding data for individual reports to be displayed in existing reports table
    isLibraryProcessing: false
};


// REDUCER
// used to manipulate application state
// takes an action, checks its type, based on that performs certain functionality, then returns new slice of state
// utilized in "_container" components
const reportsStatus = (state = defaultState, action) => {
    let newState = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case RECEIVE_CLIENT_REPORTS_DATA:
            newState.isDataReceived = true;
            newState.clientReports = action.data;
            return newState;
        case GET_CLIENT_EMAILS:
            newState.clientEmails = action.data;
            return newState;
        case UPDATE_MODE:
            newState.mode = action.mode;
            return newState;
        case SET_LIBRARY_PRICESSING:
            newState.isLibraryProcessing = action.state;
            return newState;
        case REMOVE_REPORT_DATA:
            newState.clientReports = newState.clientReports.filter(report => report.uuid !== action.reportUUID);
            return newState;
        case CLEAR_ALL_STATES:
            return defaultState;
        default:
            return state;
    }
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default reportsStatus;
